// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1BpML","content":"Consent_content__2IND5","footer":"Consent_footer__17V0J"};